export enum AuthProvider {
    GOOGLE
}

export interface LoginBody {
    username: string;
    password: string;
}

export interface AuthClientJsonWebToken {
    provider: AuthProvider;
    jwt: string;
}

export interface Auth {
    token: string;
    id: number;
    email?: string;
    name: string;
    firstName?: string;
    lastName?: string;
    username: string;
    features: {
        [key: string]: string[];
    };
    roleNames: string[];
    avatar?: string;
}

export interface BackEnd {
    apiDocsPath: string;
    commit: string;
    id: string;
    registerDate: number;
    url: string;
    version: string;
}
